__turbopack_context__.v({
  "flagItem": "CountryFlags-module__l28yPG__flagItem",
  "overflow": "CountryFlags-module__l28yPG__overflow",
  "stackedFlagsContainer": "CountryFlags-module__l28yPG__stackedFlagsContainer",
  "tooltip": "CountryFlags-module__l28yPG__tooltip",
  "tooltipContent": "CountryFlags-module__l28yPG__tooltipContent",
  "tooltipFlag": "CountryFlags-module__l28yPG__tooltipFlag",
  "tooltipPortal": "CountryFlags-module__l28yPG__tooltipPortal",
  "tooltipWrapper": "CountryFlags-module__l28yPG__tooltipWrapper",
  "visible": "CountryFlags-module__l28yPG__visible",
});
